export default "__VITE_ASSET__DI8uPH7R__"